var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "logs-wrapper", class: { "has-header": _vm.hasHeader } },
    [
      !_vm.logTickets || _vm.logTickets.length <= 0
        ? _c("div", { staticClass: "no-ticket" }, [
            _vm._v(" " + _vm._s(_vm.$t("No tickets earned")) + " "),
          ])
        : _vm._e(),
      _vm._l(_vm.logTicketsWithDateInfo, function (ticket) {
        return _c(
          "div",
          { key: ticket.label || ticket.id, staticClass: "ticket-log" },
          [
            ticket.type === "date-label"
              ? _c("div", { staticClass: "date-label" }, [
                  _vm._v(_vm._s(ticket.label)),
                ])
              : _c("div", { staticClass: "details" }, [
                  _c("div", { staticClass: "image-wrapper" }, [
                    ticket.jackpot.type === 0
                      ? _c("img", {
                          attrs: {
                            src: require(`@/assets/images/${_vm.getTicketType(
                              ticket.jackpotTicket.color
                            )}-ticket.webp`),
                          },
                        })
                      : _vm._e(),
                    ticket.jackpot.type === 1
                      ? _c("img", {
                          attrs: {
                            src: require(`@/assets/images/instant-prize.webp`),
                          },
                        })
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "log-text" }, [
                    _vm._v(_vm._s(_vm.ticketLogText(ticket))),
                  ]),
                  _c("div", { staticClass: "created-date" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getTicketDate(ticket.createdDateTime)) +
                        " "
                    ),
                  ]),
                ]),
          ]
        )
      }),
      _vm.hasMoreTicket
        ? _c(
            "button",
            { staticClass: "load-more", on: { click: _vm.loadMoreTickets } },
            [_vm._v(_vm._s(_vm.loadMoreText))]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }